import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import partial from 'lodash/partial';
import { getProject } from 'project/ducks/project';
import { fetchUnderNegotiation, setOfferNegotiationAction } from 'entries/ducks';
import { getProjectIdFromUrl } from 'project/utils';
import PendingOffers from 'entries/components/pending_offers';

const mapStateToProps = (state) => {
  const user = state.user.profile_data;
  const project = getProject(state);

  return {
    show: (
      !!user.id && !!project.id &&
      (user.id === project.client || project.creative_ids.includes(user.id))
    ),
    entries: state.entries.underNegotiation,
    project,
    user
  };
};

const mapDispatchToProps = (dispatch, { params }) => {
  const projectId = getProjectIdFromUrl(params);

  return bindActionCreators({
    fetch: partial(fetchUnderNegotiation, projectId),
    setOfferNegotiationAction
  }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PendingOffers));



// WEBPACK FOOTER //
// ./entries/containers/pending_offers.js